export const FILTER_OPTION_TYPE = {
  CHECKBOX: "checkbox",
  DATE_RANGE: "dateRange",
  DATE_TIME_RANGE: "dateTimeRange",
  DATE_PRESET_RANGE: "datePresetRange",
  FREE_TEXT: "freeText",
  AUTO_COMPLETE: "autoComplete",
  MULTIPLE_AUTOCOMPLETE: "multipleAutocomplete",
  AUTOCOMPLETE_WITH_CHECKBOX: "autocompleteWithCheckbox",
} as const;
